import React, { useState, useEffect } from 'react';
import Icon from '../../components/Icon';

function PositionBadge({ pos }) {
  if (!pos) return null;
  return <span className="lor-trade-player-pos">{pos}</span>;
}

function TradeSide({ side }) {
  if (!side) return null;
  const { manager, header, players, context } = side;
  return (
    <div className="lor-trade-side">
      <div className="lor-trade-side-header">{header || manager}</div>
      <div className="lor-trade-players">
        {(players || []).map((p, i) => (
          <div key={i} className="lor-trade-player">
            <PositionBadge pos={p.position} />
            <span className="lor-trade-player-name">{p.name || p}</span>
            {p.detail && (
              <span className="lor-trade-player-detail">{p.detail}</span>
            )}
          </div>
        ))}
      </div>
      {context && (
        <div className="lor-trade-side-context">{context}</div>
      )}
    </div>
  );
}

export default function LORTheTrade({ api }) {
  const [trade, setTrade]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    fetch(`${api}/api/lor/lore/the-trade`)
      .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(data => { setTrade(data); setLoading(false); })
      .catch(() => { setError('The Trade data is unavailable.'); setLoading(false); });
  }, [api]);

  if (loading) return <div className="lor-loading">Loading The Trade…</div>;
  if (error)   return <div className="lor-empty">{error}</div>;

  const t = trade || {};

  return (
    <div className="lor-trade-page">
      {/* Hero */}
      <div className="lor-trade-hero">
        <div className="lor-trade-hero-date">{t.date || 'November 7, 2018'}</div>
        <h2 className="lor-trade-hero-title">{t.title || 'The Trade'}</h2>
        {t.subtitle && (
          <div className="lor-trade-hero-subtitle">{t.subtitle}</div>
        )}
      </div>

      {/* Exchange */}
      <div className="lor-trade-exchange lor-card">
        <TradeSide side={t.sends_side} />
        <div className="lor-trade-arrow"><Icon emoji="⇄" size={20} /></div>
        <TradeSide side={t.receives_side} />
      </div>

      {/* Full narrative quote */}
      {t.narrative && (
        <div className="lor-trade-quote lor-card">
          <div className="lor-trade-quote-icon">📰</div>
          <blockquote className="lor-trade-quote-text">"{t.narrative}"</blockquote>
        </div>
      )}

      {/* Context card */}
      {t.context && (
        <div className="lor-trade-section-card lor-card">
          <div className="lor-trade-section-label">Before The Trade</div>
          <p className="lor-trade-section-body">{t.context}</p>
        </div>
      )}

      {/* Result card */}
      {t.result && (
        <div className="lor-trade-section-card lor-card">
          <div className="lor-trade-section-label">What Happened After</div>
          <p className="lor-trade-section-body">{t.result}</p>
        </div>
      )}

      {/* Legacy card */}
      {t.legacy && (
        <div className="lor-trade-section-card lor-card">
          <div className="lor-trade-section-label">The Legacy</div>
          <p className="lor-trade-section-body">{t.legacy}</p>
        </div>
      )}

      {/* Commissioner approval badge */}
      <div className="lor-trade-commissioner-badge">
        <span className="lor-trade-commissioner-badge-inner">
          <Icon emoji="✓" size={12} style={{ verticalAlign: 'middle', marginRight: 4 }} /> Approved by PhillyxCommish
        </span>
      </div>
    </div>
  );
}
